/**
 * Pufien — DIY otomatik hediye çorap (app YOK).
 *
 * Kural (V3, 10 Ekim 2026 — yönetici: "hediye çorap bebek patiklerine özel, 17-18-19 numaralara"):
 *   • Sepette 17, 18 ya da 19 numaralı bir ürün varsa → hediye çorap (0₺) otomatik EKLENİR.
 *   • Yoksa → hediye çorap otomatik ÇIKARILIR. (Eski: V2 her ücretli sepet; ondan önce 100 TL eşiği.)
 *   • Adet 1'e sabit. (UI'da stepper gizli; silme butonu güvenlik için açık.)
 *
 * KRİTİK: mevcut hediye satırını değiştirirken/silerken VARYANT ID değil,
 * cart.js'ten gelen SATIR ANAHTARI (item.key) kullanılır — /cart/change.js
 * varyant id'yi (sayı) bazen satır-index sanıp işi sessizce boşa çıkarıyordu
 * (add çalışıp remove çalışmamasının sebebi buydu).
 *
 * Sağlamlık: cart:update olayı + tüm /cart/{add,change,update,clear} fetch
 * interception + /cart.js cache:'no-store'. Kendi mutasyonları döngüye sokulmaz.
 * Hepsi try/catch → sepeti bozmaz.
 */
import { CartUpdateEvent, ThemeEvents } from '@theme/events';

const GIFT_ID = Number(window.PF_GIFT_VARIANT_ID || 0);
const UYGUN_NUMARA = ['17', '18', '19']; // V3: yalnız bu numaralar (variant_options / options_with_values)
const SOURCE = 'pf-free-gift';

if (GIFT_ID > 0) {
  let busy = false;
  let selfMutating = false;

  const sectionIds = () => {
    const ids = new Set();
    document.querySelectorAll('cart-items-component').forEach((el) => {
      if (el.dataset && el.dataset.sectionId) ids.add(el.dataset.sectionId);
    });
    return Array.from(ids);
  };

  const getCart = async () =>
    (await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();

  const post = async (url, body) => {
    selfMutating = true;
    try {
      return await (await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        cache: 'no-store',
        body: JSON.stringify(body),
      })).json();
    } finally {
      selfMutating = false;
    }
  };

  const isGift = (i) => i && (i.id === GIFT_ID || i.variant_id === GIFT_ID);

  const reconcile = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await getCart();
      const items = Array.isArray(cart.items) ? cart.items : [];
      const gift = items.find(isGift);
      const numarali = (i) =>
        (i.variant_options || []).some((v) => UYGUN_NUMARA.includes(String(v).trim())) ||
        (i.options_with_values || []).some((o) => UYGUN_NUMARA.includes(String(o.value).trim()));
      const uygun = items.some((i) => !isGift(i) && numarali(i));
      const secParam = sectionIds().join(',');
      let resp = null;

      if (uygun) {
        if (!gift) {
          resp = await post('/cart/add.js', {
            items: [{ id: GIFT_ID, quantity: 1 }], sections: secParam, sections_url: location.pathname,
          });
        } else if (gift.quantity !== 1) {
          resp = await post('/cart/change.js', {
            id: gift.key, quantity: 1, sections: secParam, sections_url: location.pathname,
          });
        }
      } else if (gift) {
        // 17-18-19 numaralı ürün yok → hediyeyi çıkar. SATIR ANAHTARI ile (kesin tanımlayıcı).
        resp = await post('/cart/change.js', {
          id: gift.key, quantity: 0, sections: secParam, sections_url: location.pathname,
        });
      }

      if (resp) {
        const fresh = await getCart();
        document.dispatchEvent(
          new CartUpdateEvent(fresh, SOURCE, { source: SOURCE, sections: resp.sections })
        );
      }
    } catch (e) {
      if (window.console && console.warn) console.warn('[pf-free-gift]', e);
    } finally {
      busy = false;
    }
  };

  const trigger = () => setTimeout(reconcile, 150);

  document.addEventListener(ThemeEvents.cartUpdate, (e) => {
    if (e && e.detail && e.detail.data && e.detail.data.source === SOURCE) return;
    trigger();
  });

  const origFetch = window.fetch;
  window.fetch = function (...args) {
    let url = '';
    try { url = String((args[0] && args[0].url) || args[0] || ''); } catch (e) { /* no-op */ }
    const p = origFetch.apply(window, args);
    if (!selfMutating && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(() => trigger()).catch(() => {});
    }
    return p;
  };

  const start = () => setTimeout(reconcile, 400);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}
